export type Granularity = 'HOUR' | 'DAY' | 'WEEK' | 'MONTH';
export type TimeSeriesSource = 'RAW' | 'HOURLY' | 'DAILY';
export type TopMetric = 'VIEWS_GROWTH' | 'FOLLOWERS_GROWTH' | 'AVG_VIEWS_PER_REEL';
export type SchedulerRunType = 'MAIN_3H' | 'NIGHTLY_PROFILE' | 'HOURLY_ROLLUP' | 'DAILY_ROLLUP';
export type SchedulerRunStatus = 'RUNNING' | 'OK' | 'FAILED' | 'PARTIAL';
export type UserRole = 'USER' | 'WORKSPACE_ADMIN' | 'ADMIN' | 'SERVICE';

export const SCHEDULER_RUN_TYPES: readonly SchedulerRunType[] = [
  'MAIN_3H',
  'NIGHTLY_PROFILE',
  'HOURLY_ROLLUP',
  'DAILY_ROLLUP',
] as const;

export const TOP_METRICS: readonly TopMetric[] = [
  'VIEWS_GROWTH',
  'FOLLOWERS_GROWTH',
  'AVG_VIEWS_PER_REEL',
] as const;

export const TOP_METRIC_LABELS: Record<TopMetric, string> = {
  VIEWS_GROWTH: 'Croissance des vues',
  FOLLOWERS_GROWTH: 'Croissance des followers',
  AVG_VIEWS_PER_REEL: 'Vues moyennes par reel',
};

export const SCHEDULER_RUN_TYPE_LABELS: Record<SchedulerRunType, string> = {
  MAIN_3H: 'Cycle principal',
  NIGHTLY_PROFILE: 'Rafraîchissement profils',
  HOURLY_ROLLUP: 'Rollup horaire',
  DAILY_ROLLUP: 'Rollup journalier',
};

export const SCHEDULER_RUN_STATUS_LABELS: Record<SchedulerRunStatus, string> = {
  RUNNING: 'En cours',
  OK: 'Succès',
  FAILED: 'Échec',
  PARTIAL: 'Partiel',
};

export const TOP_METRIC_LABELS_EN: Record<TopMetric, string> = {
  VIEWS_GROWTH: 'Views growth',
  FOLLOWERS_GROWTH: 'Follower growth',
  AVG_VIEWS_PER_REEL: 'Average views per reel',
};

export const SCHEDULER_RUN_TYPE_LABELS_EN: Record<SchedulerRunType, string> = {
  MAIN_3H: 'Main cycle',
  NIGHTLY_PROFILE: 'Profile refresh',
  HOURLY_ROLLUP: 'Hourly rollup',
  DAILY_ROLLUP: 'Daily rollup',
};

export const SCHEDULER_RUN_STATUS_LABELS_EN: Record<SchedulerRunStatus, string> = {
  RUNNING: 'Running',
  OK: 'Success',
  FAILED: 'Failed',
  PARTIAL: 'Partial',
};
